<template>
  <div>
    <div class="col-9 ms-auto me-5 px-3 not-printing">
      <div class="col-12 d-flex justify-content-between align-items-end p-0 my-4">
        <div class="body-title mt-3">Productos a Facturar</div>

        <div>
          <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#addProductModal">
            <i class="fa-solid fa-plus me-2" id="modal-open"></i>
            Añadir productos
          </button>
          <button
            type="button"
            class="btn btn-danger"
            :disabled="!invoice.products.confirmed.length"
            @click="clearInvoiceConfirmation"
            >
            Limpiar
          </button>
        </div>
      </div>

      <div class="content-view">
        <!-- Invoice Products Table -->
        <div class="px-2" :class="invoice.products.confirmed.length ? 'has_some_products' : ''">
          <table class="table mt-3 position-relative">
            <thead>
              <th class="col-4">Nombre</th>
              <th class="col-3">Cantidad</th>
              <th class="col-2">Precio</th>
              <th class="col-2">ITBIS</th>
              <th class="col-2">Total</th>
            </thead>
            <tbody style="line-height: 33px">
              <div v-if="!invoice.products.confirmed.length" class="position-absolute top-50 start-50 translate-middle">
                <p class="mt-5 pt-5 fs-4">La factura está vacia</p>
              </div>

              <tr v-else
                v-for="(product, i) in invoice.products.confirmed" :key="i"
                :id="`product-row-${i}`"
                @mouseenter="addOrRemoveDeleteOptClass($event)"
                @mouseleave="addOrRemoveDeleteOptClass($event)"
              >
                <td>{{ product.name }}</td>
                <td class="p-auto">
                  <input
                    :id="`productAmount${i}`" type="number"
                    class="w-20 quantity currencyInput"
                    v-model="product.quantity"
                    @change="calculateInvoiceTotal($event, product)"
                    @click="selectText($event)"
                    @focus="selectText($event)"
                    @keydown.enter="enterAsTab($event)"
                    @input = "product.quantity = (product.quantity <= 0) ? 1 : product.quantity "
                  />
                </td>

                <td>RD$ {{ formatNumber(product.price) }}</td>
                <td>RD$ {{ formatNumber(product.taxes) }}</td>
                <td>RD$ {{ (product.total = productTotal(product.price, product.taxes, product.quantity)) }}</td>

                <!-- Delete Button -->
                <td class="deleteOpt text-danger fs-5" @click="removeProduct(product)">
                  <i class="bi bi-trash-fill"></i>
                </td>
              </tr>

              <tr v-if="invoice.products.confirmed.length" class="invoice-totals">
                <td class="fw-bold border-bottom-0"> Total:</td>
                <td class="fw-bold border-bottom-0 ps-2"> {{ invoice.total_quantity }} </td>
                <td class="fw-bold border-bottom-0"> RD$ {{ invoice.subtotal }} </td>
                <td class="fw-bold border-bottom-0"> RD$ {{ invoice.taxes }} </td>
                <td class="fw-bold border-bottom-0"> RD$ {{ invoice.total }} </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Invoice Buttons -->
        <div
          class="invoice-buttons d-flex justify-content-between mt-2"
          :class="!invoice.products.confirmed.length ? 'mt-2' : ''"
        >
          <button
            type="button"
            class="btn btn-danger mb-2"
            data-bs-toggle="modal"
            data-bs-target="#closeCashRegister"
            @click="getCashRegister()"
          >
            <i class="bi bi-lock-fill"></i> Cerrar Caja
          </button>

          <button
            id="enable_pay"
            type="button"
            class="btn btn-success mb-2"
            data-bs-toggle="modal"
            :disabled="!invoice.products.confirmed.length"
            data-bs-target="#confirmInvoicePayment"
            @click="calculateInvoiceTotal"
          >
            Pagar
          </button>
        </div>
      </div>

      <!-- Modals -->
      <!-- Add product to Invoice -->
      <div
        class="modal fade"
        id="addProductModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <section>
                <h5 class="modal-title fw-bold">Confirmar</h5>
              </section>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <!-- Search bar -->
              <div class="col-5">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Buscar producto(s)"
                  v-model="productSearch"
                  @keyup="getProducts()"
                />
                <!-- HACE FALTA AGREGAR ICONO PARA INPUT (Ej: el login) -->
              </div>
              <div class="table-container mt-3">
                <table class="table table-hover">
                  <thead>
                    <th class="ps-2">Nombre</th>
                    <th class="text-end pe-5">Precio</th>
                    <th class="text-center">Disponibles</th>
                  </thead>

                  <tbody ref="tbobyInvoice">
                    <tr
                      v-for="(product, i) in products"
                      :key="i"
                      :id="'tr-' + i"
                      :class="haveBeenSelected(product) ? 'selected' : ''"
                      @click="selectProduct(i)"
                    >
                      <td class="ps-2">{{ product.name }}</td>
                      <td class="text-end pe-5">
                        {{ formatNumber(product.price) }}
                      </td>
                      <td class="text-center">{{ product.units }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="AddProductsToInvoice()"
              >
                Añadir productos
              </button>

              <button
                type="button"
                class="btn btn-danger"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="clearAddProductsVariables()"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Close Cash Register -->
      <div
        class="modal fade"
        id="closeCashRegister"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="exampleModalLabel">Cerrar Caja</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <form @submit.prevent="">
                <div class="row col-12 m-0">
                  <!-- Totals -->
                  <div class="col-12 d-flex justify-content-around align-items-center my-2">
                    <div class="col-3 text-center total-container">
                      <p class="col-12 m-0 fs-4">Monto de Apertura</p>
                      <span class="col-12 fw-bold fs-4">{{ formatNumber(cashRegister.opening) }}</span>
                    </div>

                    <div class="col-3 text-center total-container">
                      <p class="col-12 m-0 fs-4">Ventas totales</p>
                      <span class="col-12 fw-bold fs-4">{{ formatNumber(cashRegister.total_cash) }}</span>
                    </div>

                    <div class="col-3 text-center total-container">
                      <p class="col-12 m-0 fs-4">Total en caja</p>
                      <span class="col-12 fw-bold fs-4">{{
                        formatNumber(+cashRegister.opening + +cashRegister.total_cash)
                      }}</span>
                    </div>
                  </div>
                  <hr />

                  <!-- Inputs -->
                  <div class="d-flex justify-content-center col-12 my-2 px-0">
                    <!-- Coins container -->
                    <div class="col-5 row">
                      <h5 class="fw-bold ps-1">Monedas:</h5>
                      <!-- fila 1 -->
                      <div class="row pe-0 ps-1 mb-2">
                        <!-- Monedas de 1 -->
                        <div class="col-4 pe-0 currency-card">
                          <span class="input-group-text fw-bold" id="basic-addon1">RD$ 1</span>
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            type="text"
                            class="form-control"
                            placeholder="Qty"
                            v-model="cashRegister.coin_1"
                            required
                          ></CurrencyInput>
                        </div>

                        <!-- Monedas de 5 -->
                        <div class="col-4 pe-0 currency-card">
                          <span class="input-group-text fw-bold" id="basic-addon1">RD$ 5</span>
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            type="text"
                            class="form-control"
                            placeholder="Qty"
                            v-model="cashRegister.coin_5"
                            required
                          >
                          </CurrencyInput>
                        </div>
                      </div>

                      <!-- fila 2 -->
                      <div class="row pe-0 ps-1">
                        <!-- Monedas de 10 -->
                        <div class="col-4 pe-0 currency-card">
                          <span class="input-group-text fw-bold" id="basic-addon1">RD$ 10</span>
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            type="text"
                            class="form-control"
                            placeholder="Qty"
                            v-model="cashRegister.coin_10"
                            required
                          >
                          </CurrencyInput>
                        </div>

                        <!-- Monedas de 25 -->
                        <div class="col-4 pe-0 currency-card">
                          <span class="input-group-text fw-bold" id="basic-addon1">RD$ 25</span>
                          <CurrencyInput
                            @keydown.enter="enterAsTab"
                            type="text"
                            class="form-control"
                            placeholder="Qty"
                            v-model="cashRegister.coin_25"
                            required
                          >
                          </CurrencyInput>
                        </div>
                      </div>

                      <!-- Footer (total) -->
                      <div class="d-flex ps-1 mt-2">
                        <h5 class="fw-bold">Total de monedas:</h5>
                        <span class="ps-1">RD$ {{ totalCoinsAmount }}</span>
                      </div>
                    </div>

                    <!-- Bills Container -->
                    <div class="col-6 d-flex flex-column">
                      <h5 class="fw-bold ps-1">Billetes:</h5>
                      <div class="d-flex flex-column align-items-center">
                        <!-- Fila de billetes -->
                        <div class="col-12 row mb-2">
                          <!-- Billetes de 50 -->
                          <div class="col-3 pe-0 ps-1 me-2 currency-card">
                            <span class="input-group-text fw-bold" id="basic-addon1">RD$ 50</span>
                            <CurrencyInput
                              @keydown.enter="enterAsTab"
                              type="text"
                              class="form-control"
                              placeholder="Qty"
                              v-model="cashRegister.bill_50"
                              required
                            ></CurrencyInput>
                          </div>
                          <!-- Billetes de 100 -->
                          <div class="col-3 pe-0 ps-1 me-2 currency-card">
                            <span class="input-group-text fw-bold" id="basic-addon1">RD$ 100</span>
                            <CurrencyInput
                              @keydown.enter="enterAsTab"
                              type="text"
                              class="form-control"
                              placeholder="Qty"
                              v-model="cashRegister.bill_100"
                              required
                            >
                            </CurrencyInput>
                          </div>
                          <!-- Billetes de 200 -->
                          <div class="col-3 pe-0 ps-1 me-2 currency-card">
                            <span class="input-group-text fw-bold" id="basic-addon1">RD$ 200</span>
                            <CurrencyInput
                              @keydown.enter="enterAsTab"
                              type="text"
                              class="form-control"
                              placeholder="Qty"
                              v-model="cashRegister.bill_200"
                              required
                            ></CurrencyInput>
                          </div>
                        </div>

                        <!-- Fila de billetes -->
                        <div class="col-12 row">
                          <!-- Billetes de 500 -->
                          <div class="col-3 pe-0 ps-1 me-2 currency-card">
                            <span class="input-group-text fw-bold" id="basic-addon1">RD$ 500</span>
                            <CurrencyInput
                              @keydown.enter="enterAsTab"
                              type="text"
                              class="form-control"
                              placeholder="Qty"
                              v-model="cashRegister.bill_500"
                              required
                            ></CurrencyInput>
                          </div>
                          <!-- Billetes de 1000 -->
                          <div class="col-3 pe-0 ps-1 me-2 currency-card">
                            <span class="input-group-text fw-bold" id="basic-addon1">RD$ 1000</span>
                            <CurrencyInput
                              @keydown.enter="enterAsTab"
                              type="text"
                              class="form-control"
                              placeholder="Qty"
                              v-model="cashRegister.bill_1000"
                              required
                            ></CurrencyInput>
                          </div>
                          <!-- Billetes de 2000 -->
                          <div class="col-3 pe-0 ps-1 me-2 currency-card">
                            <span class="input-group-text fw-bold" id="basic-addon1">RD$ 2000</span>
                            <CurrencyInput
                              @keydown.enter="enterAsTab"
                              type="text"
                              class="form-control"
                              placeholder="Qty"
                              v-model="cashRegister.bill_2000"
                              required
                            >
                            </CurrencyInput>
                          </div>
                        </div>

                        <div class="col-12 d-flex ps-1 mt-2">
                          <h5 class="fw-bold">Total de billetes:</h5>
                          <span class="ps-1">RD$ {{ totalBillsAmount }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success"
                data-bs-dismiss="modal"
                aria-label="Close"
                :disabled="+totalCoinsAmount + +totalBillsAmount < +cashRegister.total_cash + +cashRegister.opening"
                @click="closeCashRegister"
              >
                Confirmar
              </button>
              <button type="button" class="btn btn-danger" data-bs-dismiss="modal" aria-label="Close">Cerrar</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Confirm Invoice Payment -->
      <div
        class="modal fade"
        id="confirmInvoicePayment"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title fw-bold" id="exampleModalLabel">Pagar factura</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form @submit.prevent="payment()">
              <div class="modal-body">
                <div class="col-12 d-flex align-items-center pb-2">
                  <div class="me-1">
                    <label for="" class="fw-bold">Método de pago:</label>
                  </div>
                  <div class="col-5">
                    <select class="d-inline form-select text-center" v-model="invoice.payment_method" @change="calculateInvoiceTotal">
                      <option value="CASH" selected>Efectivo</option>
                      <option value="CARD">Tarjeta</option>
                    </select>
                  </div>
                </div>
                <div class="d-flex justify-content-between col-12 mt-2 pt-2 border-top">
                  <div class="col-5 form-group">
                    <label for="">Monto:</label>
                    <CurrencyInput
                      @keydown.enter="enterAsTab"
                      name="cash"
                      class="form-control col-10"
                      v-model="invoice.cash"
                    ></CurrencyInput>
                  </div>

                  <div class="col-5 form-group">
                    <label for="">Descuento (%):</label>
                    <CurrencyInput
                      @keydown.enter="enterAsTab"
                      name="discount"
                      class="form-control col-10"
                      v-model="invoice.discount"
                      @keyup="discountAmount()"
                      @change="discountAmount(true)"
                    ></CurrencyInput>
                  </div>
                </div>

                <div class="col-12 mt-4 pt-3 border-top">
                  <div class="d-flex justify-content-between">
                    <p class="my-0">Sub-total:</p>
                    <div class="d-flex justify-content-between col-4 fw-bold">
                      <span>RD$</span>
                      <span>{{ formatNumber(invoice.subtotal) }}</span>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between">
                    <p class="my-0">ITBIS:</p>
                    <div class="d-flex justify-content-between col-4 fw-bold">
                      <span>RD$</span>
                      <span>{{ formatNumber(invoice.taxes) }}</span>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between">
                    <p class="my-0">Descuento:</p>
                    <div class="d-flex justify-content-between col-4 fw-bold">
                      <span>RD$</span>
                      <span>{{ formatNumber(invoice.discount_amount) }}</span>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between" v-if='invoice.payment_method == "CARD"'>
                    <p class="my-0">CardNet (7%):</p>
                    <div class="d-flex justify-content-between col-4 fw-bold">
                      <span>RD$</span>
                      <span>{{ formatNumber(invoice.cardNet) }}</span>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between">
                    <p class="my-0">Total:</p>
                    <div class="d-flex justify-content-between col-4 fw-bold">
                      <span>RD$</span>
                      <span>{{ formatNumber(invoice.total) }}</span>
                    </div>
                  </div>

                  <div class="mt-4 d-flex justify-content-between">
                    <p class="my-0">Devuelta:</p>
                    <div class="d-flex justify-content-between col-4 fw-bold">
                      <span>RD$</span>
                      <span>{{ formatNumber(change) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer justify-content-between">
                <div class="d-flex justify-content-between">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                      @click="wantPrint = !wantPrint"
                      :checked="wantPrint"
                    />
                    <label class="form-check-label" for="flexCheckChecked">Imprimir</label>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    class="btn btn-success"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    :disabled="!canPay"
                    >
                    Confirmar
                  </button>

                  <button
                    type="button"
                    class="btn btn-danger"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    @click="clearDiscounts()"
                    >
                    Cerrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Printing Data -->
    <div class="printing">
      <div class="mb-4">
        <!-- <div class="offset-md-12 d-flex justify-content-end">
          <div class="d-flex justify-content-between">
            <span class="text-uppercase fw-bold">Factura</span>
          </div>
        </div> -->
      </div>

      <div class="mb-4">
        <div class="offset-md-12 d-flex justify-content-center">
          <!-- TITLE -->
          <div class="d-flex">
            <span class="text-uppercase fw-bold fs-4">KairosFarma</span>
          </div>
        </div>
        <!-- Direccion -->
        <div class="offset-md-12 d-flex justify-content-center">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <p class="text-uppercase m-0 ">Calle Telesforo Jaime #4, bayona</p>
            <p class="text-uppercase m-0">Santo Domingo Oeste</p>
          </div>
        </div>
        <div class="offset-md-12 d-flex justify-content-center">
          <div class="d-flex justify-content-between">
            <span>Tel: 809 466-5471</span>
          </div>
        </div>
      </div>

      <div class="col-6 mb-4">
        <div class="col-md-4">
          <span class="my-0 text-uppercase">Factura:</span>
          <span> INV-0{{ currentId }}</span>
        </div>

        <div class="d-flex">
          <span class="my-0 text-uppercase">Fecha:</span>
          <span>{{ invoice.date | dateFormat }}</span>
        </div>
      </div>

      <div class="mb-4">
        <div class="">
          <table class="table table-hover">
            <thead class="border-bottom">
              <th class="col">Nombre</th>
              <th class="col">Cantidad</th>
              <th class="col">Precio</th>
              <th class="col">ITBIS</th>
              <th class="col">Total</th>
            </thead>
            <tbody>
              <tr v-for="(product, i) in invoice.products.confirmed" :key="i">
                <td>{{ product.name }}</td>
                <td>{{ product.quantity }}</td>
                <td>{{ formatNumber(product.price) }}</td>
                <td>{{ formatNumber(product.taxes) }}</td>
                <td>{{ formatNumber(product.total) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="invoice-resume">
          <div class="col-3 d-flex justify-content-between">
            <span>SUBTOTAL:</span>
            <span>{{ formatNumber(invoice.subtotal) }}</span>
          </div>
          <div class="col-3 d-flex justify-content-between">
            <span>ITBIS:</span>
            <span>{{ formatNumber(invoice.taxes) }}</span>
          </div>
          <div class="col-3 d-flex justify-content-between">
            <span>TOTAL:</span>
            <span>{{ formatNumber(invoice.total) }}</span>
          </div>
        </div>
      </div>

      <div>
        <span>CAJERO: {{ user.name }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="js">
  import CurrencyInput from '../CurrencyInputComponent.vue';

  export default {
    components:{
      CurrencyInput,
    },

    data() {
      return {
        wantPrint			: false,
        products      : [],
        productSearch : null,
        currentId			: 0,
        user          : {
          name : null
        },

        invoice       : {
          id              : '',
          date            : moment().format('YYYY-MM-DD'),
          taxes           : '0.00',
          discount        : '0.00',
          discount_amount : '0.00',
          subtotal        : '0.00',
          total           : '0.00',
          cash           	: '0.00',
          total_quantity  : '0.00',
          payment_method  : 'CASH',
          products : {
            selected    : [],
            confirmed   : []
          }
        },

        cashRegister	: {
          coin_1			: '0.0',
          coin_5			: '0.0',
          coin_10			: '0.0',
          coin_25			: '0.0',
          bill_50			: '0.0',
          bill_100		: '0.0',
          bill_200		: '0.0',
          bill_500		: '0.0',
          bill_1000		: '0.0',
          bill_2000		: '0.0',
          opening			: '0.0',
          total_cash	: '0.0',
          status			: 'CLOSED',
        },
      }
    },

    computed:{
      /** It returns TRUE if the cash received from the client
       * is more than the invoice total otherwise it returns FALSE
       */
      canPay(){
        let result = (this.invoice.cash - this.invoice.total).toFixed(2);
        return (result >= 0) ? true : false;
      },

      /** This is the amount you need to return to the client */
      change(){
        let result = (this.invoice.cash - this.invoice.total).toFixed(2);
        return result;
      },

      /**
       * Calculate the total amount of coins
       * @return int
       */
      totalCoinsAmount(){
        return (
          +this.cashRegister.coin_1 			 +
          (this.cashRegister.coin_5  * 5)  +
          (this.cashRegister.coin_10 * 10) +
          (this.cashRegister.coin_25 * 25)
        ).toFixed(2)
      },

      /**
       * Calculate the total amout of coins
       * @return int
       */
      totalBillsAmount(){
        return (
          (+this.cashRegister.bill_50  * 50)   +
          (this.cashRegister.bill_100  * 100)  +
          (this.cashRegister.bill_200  * 200)  +
          (this.cashRegister.bill_500  * 500)  +
          (this.cashRegister.bill_1000 * 1000) +
          (this.cashRegister.bill_2000 * 2000)
        ).toFixed(2)
      }
    },

    methods:{
      getProducts(){
        axios.get('invoice/all-products',{
          params : {
            search      : this.productSearch,
            moreThanOne : true,
          }
        }).then(response => {
          this.products = response.data.products;
        });
      },

      getCurrentUser(){
        axios.get('invoice/current-user')
        .then(response => {
          this.user = response.data.user;
          this.invoice.user_id = this.user.id;
        });
      },

      /** Send data to backend and process invoice payment */
      payment(){
        axios.post('invoice',{
          invoice : this.invoice
        }).then(response => {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          if(response.data.success && !this.wantPrint){
            this.currentId = response.data.invoice_id; // Get invoice ID
            Toast.fire({
              icon: 'success',
              title: response.data.success
            });
          }else{
            Toast.fire({
              icon: 'error',
              title: response.data.error
            });
          }
        }).finally(() => {
          if(this.wantPrint){
            setTimeout(() => {
              this.print()
              this.clearInvoice();
              this.getProducts();
              this.removeSelectedClass();
            }, 1000)
          }else{
            this.clearInvoice();
            this.getProducts();
            this.removeSelectedClass();
          }
        })
      },

      /**
       * Return true or false whether the product is selected or not
       * @param product
       * */
      haveBeenSelected(product){
        let selectedP = this.invoice.products.selected.find((p) => p.id == product.id);
        let confirmedP = this.invoice.products.confirmed.find((p) => p.product_id == product.id);
        return (selectedP || confirmedP) ? true : false;
      },

      /**
       * Add or remove product from invoice.product.selected
       * @param index
       * */
      selectProduct(index){
        let confirmedPI = this.invoice.products.confirmed.findIndex(el => el.product_id == this.products[index].id);
        let selectedPI  = this.invoice.products.selected.indexOf(this.products[index]);

        (selectedPI > -1 && confirmedPI < 0)
          ? this.invoice.products.selected.splice(selectedPI, 1) // Remove product from selection
          : this.invoice.products.selected.push(this.products[index]); // Product haven't been selected before.
      },

      removeProduct(product){
        let confirmedPI = this.invoice.products.confirmed.findIndex(p => p.product_id == product.product_id);

        if(confirmedPI > -1) this.invoice.products.confirmed.splice(confirmedPI,1);
        this.calculateInvoiceTotal()
        this.invoice.products.selected = [];
      },

      AddProductsToInvoice(){
        this.invoice.products.selected.forEach(selected => {
          let exists = this.invoice.products.confirmed.findIndex(confirmed => confirmed.product_id == selected.id) < 0;
          if(exists){
            this.invoice.products.confirmed.push({
              'product_id' : selected.id,
              'price'      : selected.price,
              'taxes'      : selected.taxes,
              'cost'       : selected.cost,
              'quantity'   : 1,
              'name'       : selected.name,
              'units'      : selected.units,
            });
          }
        });
        this.calculateInvoiceTotal();
      },

      /** Remove selected class from each rows */
      removeSelectedClass(){
        let rows = this.$refs.tbobyInvoice.children; //
        for (let index = 0; index < rows.length; index++) {
          rows[index].classList.remove("selected");
        }
      },

      clearAddProductsVariables(){
        this.productSearch = '';
        this.getProducts();
        this.invoice.products.selected = [];
      },

      maxDiscount(){
        (this.invoice.discount > 100)
          ? this.invoice.discount = "100.00"
          : this.invoice.discount
      },

      clearInvoiceConfirmation(){
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: true,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        });

        Toast.fire({
          icon            : 'warning',
          title           : "¿Deseas limpiar la factura?",
          text            : "Perderas la informacion de los productos agregados",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.clearInvoice();
            Toast.fire({
              icon              : 'success',
              title             : 'Factura limpia!',
              text              : 'Ya puedes continuar facturando desde cero.',
              confirmButtonText : 'De acuerdo',
              timer             : 3000,
            });
          }
        })
      },

      /** Clear invoice */
      clearInvoice(){
        this.invoice = {
          user_id         : this.user.id,
          date            : moment().format('YYYY-MM-DD'),
          taxes           : '0.00',
          discount        : '0.00',
          discount_amount : '0.00',
          subtotal        : '0.00',
          total           : '0.00',
          products 		  : {
            selected  : [],
            confirmed : []
          }
        }
        this.wantPrint = false;
        this.removeSelectedClass();
      },

      /** Clear invoice discount variables */
      clearDiscounts(){
        this.invoice.discount = "0.00";
        this.invoice.discount_amount = "0.00";
      },

      productTotal(price,taxes,qty){
        if(qty == '') qty = 0;
        return isNaN(qty) ? 0 : (+price + +taxes) * qty;
      },

      /** Set discount amount based in the discount percentage
       * @param checkMaxDiscout - Also check if the max discount is not above 100
      */
      discountAmount(checkMaxDiscout = false){
        (checkMaxDiscout) ? this.maxDiscount() : ''; // check if the max discount is not above 100
        this.invoice.discount_amount = (this.invoice.subtotal * (+this.invoice.discount / 100)).toFixed(2);
        this.calculateInvoiceTotal();
      },

      /**
       * validate if the units are larger than the quantity and add input alert style
       * @param event input event
       * @param product selected product
       */
      productAmountError(event, product) {
        let input = document.getElementById(event.target.id);
        let pay 	= document.querySelector("#enable_pay");
        if (product.quantity > product.units) {
          Swal.fire({
            icon  : 'error',
            title : 'Cantidad insuficiente',
            text  : `El producto ${product.name} sobrepasa la cantidad de unidades disponible, solo tienes ${product.units} disponibles`,
          });

          input.classList.add("highlight-row");
          pay.disabled = true;
        } else {
          input.classList.remove("highlight-row");
          pay.disabled = false;
        }
      },

      /**
       * Calculate all invoice total
       * @param event input event
       * @param product selected product
       */
      calculateInvoiceTotal(event = null, product = null){
        (event && product) ? this.productAmountError(event, product) : ''; // verify if the units are larger than the quantity

        /* Factorizar - Hacer que se recorra el array una sola vez */
        this.invoice.subtotal = this.invoice.products.confirmed.reduce(
          (acc, element) => (acc + (element.price * element.quantity)), 0.0
        ).toFixed(2);

        this.invoice.taxes = this.invoice.products.confirmed.reduce(
          (acc, element) =>( acc + (element.taxes * element.quantity)), 0.0
        ).toFixed(2);

        this.invoice.total_quantity = this.invoice.products.confirmed.reduce(
          (acc, element) => ( acc + +element.quantity), 0.0
        );

        let total = (
          (+this.invoice.subtotal) +
          (+this.invoice.taxes) -
          this.invoice.discount_amount
        ).toFixed(2)

        this.invoice.cardNet = (+total * 0.07).toFixed(2);

        if(this.invoice.payment_method == "CARD"){
          total = +this.invoice.cardNet + +total;
        }

        this.invoice.total = total;
      },

      getCashRegister(){
        axios.get('/cashregister/get-last-cash-register')
        .then((res) => {
          let cashR 									 = res.data.cashRegister;
          this.cashRegister.id 				 = cashR.id;
          this.cashRegister.total_cash = cashR.total_cash;
          this.cashRegister.opening 	 = cashR.opening;
        })
      },

      closeCashRegister(){
        this.cashRegister.total_bills = this.totalBillsAmount;
        this.cashRegister.total_coins = this.totalCoinsAmount;
        // this.cashRegister.status = "CLOSED";

        axios.put(`/cashregister/${this.cashRegister.id}`, this.cashRegister)
        .then((res) => {
          console.log(res.data);
          if(res.data.success){
            window.location.href = "/";
          }
        })
        .catch((error) => {
          /* Aqui va un SWAL para manejar el error*/
        })
      },
    },
    filters: {
      dateFormat(date) {
        return moment(date).locale('es').format('DD MMMM YYYY');
      }
    },
    created(){
      this.getProducts();
      this.getCurrentUser();
    },
  }
</script>

<style lang="scss" scoped>
.form-group {
  label {
    color: var(--first-color-dark);
  }
}

.invoice-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.content-view {
  :first-child.has_some_products {
    max-height: 380px;
    overflow: auto;
  }
}

.table-container {
  overflow: auto;
  max-height: 288px !important;
}

/* Table styles */
table {
  th {
    color: var(--first-color-dark);
  }
  tbody{
    p {
      color:var(--first-color-dark) ;
      background: none;
    }

    td {
      padding: 0;
      background: none;
    }
    .invoice-totals{
      td{
        padding-top: 10px;
      }
    }
  }
}

.modal-body {
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(57, 48, 48);
    border-radius: 10px;
  }
}
.total-container {
  padding: 10px 0px;
  border-radius: 5px;
  background: #f5f5f5;
  border: 1px solid var(--secondary-color-light);
}

.currency-card {
  span {
    justify-content: center;
    border-radius: 0.5rem 0.5rem 0 0 !important;
  }
  input {
    text-align: center;
    border-radius: 0 0 0.5rem 0.5rem !important;
  }
}

.col-5 .currency-card {
  width: 40% !important;
}
.col-6 .currency-card {
  width: 31% !important;
}

.printing{
  .invoice-resume{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
  }
}
</style>
